import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

import { configState } from '@chainlit/react-client';

export function useAssistants() {
  const config = useRecoilValue(configState);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Wait for Chainlit config to load with chat profiles
    if (config?.chatProfiles) {
      setLoading(false);
    }
  }, [config]);

  // Extract assistants from Chainlit's native chat profiles
  const assistants = config?.chatProfiles || [];
  const defaultAssistant = assistants.find((p) => p.default) || assistants[0] || null;

  return { 
    assistants, 
    loading, 
    defaultAssistant,
    // Note: Profile switching is handled by Chainlit's useChatInteract hook
  };
}
